import { render, staticRenderFns } from "./explorerSystemInfo.vue?vue&type=template&id=087bd262&scoped=true"
import script from "./explorerSystemInfo.vue?vue&type=script&lang=js"
export * from "./explorerSystemInfo.vue?vue&type=script&lang=js"
import style0 from "./explorerSystemInfo.vue?vue&type=style&index=0&id=087bd262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087bd262",
  null
  
)

export default component.exports